<template>
  <div>
    <div v-if="aboveThresh" class="container bordered">
       <transition name="slide">
      <div class="columns is-gapless is-marginless is-centered">
        <div class="column is-one-quarter rate has-text-right">
          <animated-number :value="currentrate" :duration="duration" :formatValue="formatToNum" />
        </div>
        <div class="column is-one-fifth blk">
          <div class="trend" :style="{ backgroundImage: 'url(' + require('@/assets/dangheart.png') + ')' }">
          <trend
            :data="ratehistory"
            :gradient="['#ffd700']"
            auto-draw
            smooth
            stroke-width="4"
          ></trend>
          </div>
          <span class="desc">BPM</span>
        </div>
      </div>
       </transition>
    </div>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/camelcase */
import Amplify, { PubSub } from "aws-amplify";
import { AWSIoTProvider } from "@aws-amplify/pubsub/lib/Providers";
import AnimatedNumber from "animated-number-vue";
export default {
  name: "HRM",
  components: {
    AnimatedNumber
  },
  data() {
    return {
      ratehistory: [],
      currentrate: 0,
      duration: 200,
      aboveThresh:false
    };
  },
  methods: {
    updateHRM(data) {
      const threshold = parseInt(process.env.VUE_APP_HRTHRESHOLD) || 80;
      const hr = data.value.hr;
      this.currentrate = hr;

      this.aboveThresh = hr >= threshold;

      this.ratehistory.push(hr);

      if(this.ratehistory.length > 60){
        this.ratehistory.shift();
      }
    },
    formatToNum(value) {
      return Number(value).toFixed(0);
    }
  },
  mounted() {
    Amplify.configure({
      Auth: {
        identityPoolId: process.env.VUE_APP_IDENTITY_POOL_ID,
        region: process.env.VUE_APP_REGION,
        userPoolId: process.env.VUE_APP_USER_POOL_ID,
        userPoolWebClientId: process.env.VUE_APP_USER_POOL_WEB_CLIENT_ID
      }
    });
    Amplify.addPluggable(
      new AWSIoTProvider({
        aws_pubsub_region: process.env.VUE_APP_REGION,
        aws_pubsub_endpoint: `wss://${process.env.VUE_APP_MQTT_ID}.iot.${process.env.VUE_APP_REGION}.amazonaws.com/mqtt`
      })
    );
    PubSub.subscribe("dg-heartrate").subscribe({
      next: data => this.updateHRM(data) //,
      //error: error => console.error(error),
      //close: () => console.log("Done")
    });
  }
};
</script>

<style>
.count {
  font-size: 13em;
  font-weight: bolder;
  color: white;
}
.lbx {
  font-weight: bolder;
  font-size: 4em;
}
.lb3 {
  font-weight: bolder;
  font-size: 3em;
  padding: 3px;
}
.statusblock {
  display: inline-block;
  margin-top: 5px;
}

.dark {
  background-color: black;
  margin-left: 0px;
  margin-right: 0px;
}

.kills {
  color: #98f881;
}
.assists {
  color: #f8f481;
}
.deaths {
  color: #f88181;
}

.wicon {
  float: left;
  margin: 3px;
  margin-top: -2px;
}

.status {
  font-weight: bolder;
  font-size: 6em;
  padding-top: 10px;
}
.trend{
  background-size:     contain;                      
  background-repeat:   no-repeat;
  background-position: center center;      
}

.fire {
  animation: burning 4s cubic-bezier(0.23, 1, 0.32, 1) both;
}

.flashed {
  animation: flashed 4s cubic-bezier(0.23, 1, 0.32, 1) both;
}

.money {
  color: white;
  background-color: #40dc16;
}

.health {
  color: white;
  background-color: #e22c2b;
}

.armor {
  color: white;
  background-color: #0c2df7;
}
.mvps {
  color: white;
  background: linear-gradient(
    0deg,
    rgba(119, 96, 0, 1) 0%,
    rgba(209, 170, 1, 1) 100%
  );
}
.blk{
  display:block;
}
.rate{
  font-size: 10em;
}
.desc{
  font-size: 5em ;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

.slide-enter-active {
  -webkit-animation: slide-in-blurred-bottom 0.6s cubic-bezier(0.23, 1, 0.32, 1)
    both;
  animation: slide-in-blurred-bottom 0.6s cubic-bezier(0.23, 1, 0.32, 1) both;
}
.slide-leave-active {
  opacity: 0;
}
.slide-enter,
.slide-leave-to {
  opacity: 0;
}

@-webkit-keyframes slide-in-blurred-bottom {
  0% {
    -webkit-transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    color: #98f881;
    opacity: 0;
  }
  80% {
    color: #98f881;
  }
  100% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    color: white;
    opacity: 1;
  }
}
@keyframes slide-in-blurred-bottom {
  0% {
    -webkit-transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    transform: translateY(1000px) scaleY(2.5) scaleX(0.2);
    -webkit-transform-origin: 50% 100%;
    transform-origin: 50% 100%;
    -webkit-filter: blur(40px);
    filter: blur(40px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateY(0) scaleY(1) scaleX(1);
    transform: translateY(0) scaleY(1) scaleX(1);
    -webkit-transform-origin: 50% 50%;
    transform-origin: 50% 50%;
    -webkit-filter: blur(0);
    filter: blur(0);
    opacity: 1;
  }
}

@keyframes flashed {
  0% {
    background-color: #efeded;
    color: black;
  }
  95% {
    background-color: #efeded;
    color: black;
  }
  100% {
    background-color: black;
    color: white;
  }
}

@keyframes burning {
  0% {
    background-color: #fcb47a;
    color: black;
  }
  95% {
    background-color: #fcb47a;
    color: black;
  }
  100% {
    background-color: black;
    color: white;
  }
}
</style>
